import React, { Component } from 'react';
import './App.css';
import Login from './Pages/Login.js'
import Portal from './Pages/Portal.js'
import Loading from './Pages/Loading.js'
import firebase from './Firebase.js'
import DB from './db.js'
//https://github.com/ReactTraining/history
import createBrowserHistory from 'history/createBrowserHistory'

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			"user": null,
			"users": {},
			"error": null,
			"compNotReady": ["Note", "Login"],
			"history": createBrowserHistory()
		};
		
		// Bind Allow access by "this" into the function
		this.loginData = this.loginData.bind(this);
		this.logOut = this.logOut.bind(this);
		this.getUser = this.getUser.bind(this);
		this.users = this.users.bind(this);
		
		let self = this
		firebase.auth().onAuthStateChanged(function(user) {
			self.state.compNotReady = [];
			if (user){
				self.state.user = user
				self.usersData()
				//console.log(user);
				//self.state.compNotReady.splice(self.state.compNotReady.indexOf("Login"), 1)
			}else
				self.setState(self.state)
		});
	}

	componentDidMount(){
	}
	
	loginData(loginD){
		let self = this,
			state = self.state

		firebase.auth().signInWithEmailAndPassword(loginD.email, loginD.password).catch(function(error) {
			// Handle Errors here.
			//var errorCode = error.code;
			var errorMessage = error.message;
			console.warn(errorMessage);

		}).then(function(d){
			
			if(d){
				self.state.history.push("/note")

				console.info('Connected.');
				state.user = d.user
				let user = d.user

				//Add user into db users
				let ref = firebase.database().ref("users")
				ref.child(user.uid).set({
					"uid": user.uid,
					"email": user.email,
					"creationTime": user.metadata.creationTime,
					"lastSignInTime": user.metadata.lastSignInTime,
					"photoURL": user.photoURL
				}).then(() => {
					console.info('Success, User saved into firebase.')
				}).catch(e => {
					console.warn("Error when trying to save this user in firebase.")
				});
			}else{
				state.error = "Wrong informations."
			}
			self.setState(state);
		});
	}

	logOut(){
		let self = this

		firebase.auth().signOut().then(function() {
			// Sign-out successful.
			self.setState(Object.assign(self.state, {"user": null}))
		}).catch(function(error) {
			// An error happened.			
			console.warn("Error, Log out impossible.");
		});
	}

	usersData(){
		var self = this
		DB.init(firebase).load("users", {orderByKey: true}, (data) => {
			let d = data.val()
			console.info(d);
			if(d){
				self.setState(Object.assign(self.state, {"users": d}))
			}else
				console.warn("Error duriong load of users list");
		})
	}

	users(users){
		if(typeof users !== "undefined")
		this.setState(Object.assign(this.state, {"users": users}))
		else
		return this.state.users;
	}

	getUser(user){
		if(user === false){
			this.logOut()
		}else
			return this.state.user
	}

	render() {
		return (
			<div className="App">
				<Login mustShow={this.state.compNotReady.length === 0 && !this.state.user? true : false} loginData={this.loginData} error={this.state.error}></Login>
				<Portal history={this.props.history} mustShow={this.state.user? true : false} getUser={this.getUser} users={this.users}/>
				<Loading compNotReady={this.state.compNotReady}></Loading>
			</div>
		);
	}
}

//<Note mustShow={this.state.user? true : false} logOut={this.logOut} user={this.state.user}></Note>
export default App;



// WEBPACK FOOTER //
// ./src/App.js